<template>
    <div class="w-full">
        <ul class="flex flex-row">
            <li class="mr-8">
                <vs-radio :color="radioButtonColor" v-model="paymentOptionType" vs-value="1">One Time</vs-radio>
            </li>
            <li class="mr-8">
                <vs-radio :color="radioButtonColor" v-model="paymentOptionType" vs-value="2">Recurring</vs-radio>
            </li>
            <li class="mr-8">
                <vs-radio :color="radioButtonColor" v-model="paymentOptionType" vs-value="3">Installments</vs-radio>
            </li>
        </ul>
        <div class="mt-4">
            <text-area class="mb-8 w-full" v-model="priceDescription" value="priceDescription" :placeholder="$t('frontend_product_step2_price_description')"/>
            <div class="flex flex-row w-full mb-8">
                <text-input class="w-1/3 mr-8 pricePointsPrice" v-model="price" value="price" :placeholder="$t('frontend_product_step2_price')"/>
                <text-input class="w-1/3 mr-8 pricePointsInstallments" v-if="paymentOptionType == 3" v-model="noOfInstallments" value="noOfInstallments" :placeholder="$t('frontend_gduikit_pricepoint_no_of_installments')"/>
                <gd-dropdown class="w-1/4 mr-8 recurringIntervalDropdown" v-if="paymentOptionType != 1" v-model="recurringIntervalValue" :value="recurringIntervalValue" :options="recurringOptionsList"></gd-dropdown>
                <label class="w-1/3 mr-8 pt-3" v-if="paymentOptionType == 2">Until Cancelled By Customer</label>
            </div>
            <div class="">
                <span class="mr-4">Set As Default Price</span>
                <gd-toggle :value="isDefaultPrice" @change="isDefaultPrice = !isDefaultPrice"/>
            </div>
        </div>
    </div>
</template>

<script>
import themeConfig from '@/theme/themeConfig.js';

export default {
  name: 'price-point',
  props: ['pricePoint'],
  methods: {
  },
  data() {
    return {
      radioButtonColor: themeConfig.appPrimaryColor,
      recurringOptionsList: [
        { text: 'Weekly', value: 1 },
        { text: 'Every 2 Weeks', value: 2 },
        { text: 'Monthly', value: 3 },
        { text: 'Every 2 Months', value: 4 },
        { text: 'Quarterly', value: 5 },
        { text: 'Half-Yearly', value: 6 },
        { text: 'Yearly', value: 7 },
        { text: 'Every 2 Years', value: 8 },
      ],
    };
  },
  created() {
  },
  computed: {
    paymentOptionType() {
      return this.pricePoint.paymentOptionType;
    },

    priceDescription() {
      return this.pricePoint.priceDescription;
    },

    price() {
      return this.pricePoint.price;
    },

    recurringIntervalValue() {
      return this.pricePoint.recurringIntervalValue;
    },


    noOfInstallments() {
      return this.pricePoint.noOfInstallments;
    },

    isDefaultPrice() {
      return this.pricePoint.isDefaultPrice;
    },
  },
};
</script>
